// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  defaultDataIdFromObject as importedDefaultDataIdFromObject,
  InMemoryCache,
} from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { isPlainObject } from 'lodash';

export const defaultDataIdFromObject = importedDefaultDataIdFromObject;

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, path, extensions }) => {
      console.error(`[GraphQL error]: Message: ${message}, Path: ${path}`);
      const stacktrace =
        extensions && extensions.exception && extensions.exception.stacktrace;
      if (stacktrace) {
        console.error(stacktrace.join('\n'));
      }
    });
  }

  if (networkError) {
    console.error(`[Network Error]: ${networkError}`);
  }
});

export function createClientLink(uri, authTokenCallback) {
  const httpLink = new BatchHttpLink({ uri });
  const authLink = setContext(async (_, { headers }) => {
    const token = await authTokenCallback();
    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    headers = {
      ...headers,
      'X-Client-Version': window.ReactAppEnv.version || '0',
      'X-Client-Path': window.location.pathname,
    };

    return { headers };
  });
  return ApolloLink.from([errorLink, authLink, httpLink]);
}

export function createAuthenticatedApolloClient(options) {
  options = { ...options };
  options.link =
    options.link || createClientLink(options.uri, options.authTokenCallback);
  options.cache =
    options.cache && !isPlainObject(options.cache)
      ? options.cache
      : new InMemoryCache(options.cache);
  return new ApolloClient(options);
}
